export default {
  props: [
    'isMiniMenu'
  ],
  data () {
    return {
    }
  },
  methods: {
    changeIsMiniMenu () {
      this.$emit('sidebar-toggle-mini-menu')
    },
    changeRoute (route) {
      this.$router.push({ name: route })
    }
  }
}
